/*
 Sempre que fizer alguma alteração em qualquer Schema:

 /sections
 /layout
 /pages
 /common

 Altere o valor!!! 
 Isso fará os dados serem atualizados conforme o novo schema quando o hotsite for carregado!
*/

export const CURRENT_PAGE_VERSION = '2.00'
export const CURRENT_STYLE_VERSION = '2.02'
export const CURRENT_SECTION_VERSION = '2.031'